// extracted by mini-css-extract-plugin
module.exports = {"lockHeader":"styles_lockHeader__iD8_n","withoutSeparator":"styles_withoutSeparator__sk6yr","lockHeaderItem":"styles_lockHeaderItem__wL0Ac"};